<template>
  <div>
    <div>
      <div ref='chartUe' style='width:1000px; height: 300px'></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import Vue from 'vue';
import { EventBus } from '../../plugins/eventBus';

Vue.prototype.$echarts = echarts;
export default {
  name: 'UeChart',
  components: {
    // echarts
  },
  data() {
    return {
      chartUe: null, // 图表
      data1: [],
      data2: [],
      qryParams: '',
      timer: ''
    };
  },
  mounted() {
    this.initChartUe();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    initChartUe() {
      this.chartUe = this.$echarts.init(this.$refs.chartUe);
      const This = this;
      this.chartUe.setOption({
        legend: {
          data: [this.$t('UE.ue_ul_Traffic'), this.$t('UE.ue_dl_Traffic')]
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            // console.log("params",params);
            const res = `${This.longtoString(params[0].data[0])}<br/>${params[0].seriesName}->${params[0].data[1]}<br/>${params[1].seriesName}->${params[1].data[1]}<br/>`;
            return res;
          },
          axisPointer: {
            animation: false
          }
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show: false
          }
        },
        series: [{
          name: this.$t('UE.ue_ul_Traffic'),
          type: 'line',
          data: this.data1
        }, {
          name: this.$t('UE.ue_dl_Traffic'),
          type: 'line',
          data: this.data2
        }]
      });
    },
    queryData(qryParams) {
      if (qryParams !== undefined) {
        this.qryParams = qryParams;
        this.timer = setInterval(this.queryData, 5000);
      }
      const This = this;
      this.$axios.post('/lte/ems/subscriber/epcunms/requestCommon', this.qryParams).then((response) => {
        const res = response.data.resultVal;
        if (response.status === 200 && res !== null) {
          const timeNow = new Date().getTime();
          This.data1.push([timeNow, parseInt(res.resultlist[0].data1, 10)]);
          This.data2.push([timeNow, parseInt(res.resultlist[0].data2, 10)]);
          This.chartUe.setOption({
            series: [{
              data: This.data1
            }, {
              data: This.data2
            }]
          });
          // EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
        } else {
          EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
        }
      });
      // setInterval(this.queryData(this.qryParams), 5000);
    },
    longtoString(longTypeDate) {
      let datetimeType = '';
      const date = new Date();
      date.setTime(longTypeDate);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const strDate = date.getDate().toString().padStart(2, '0');
      datetimeType = `${date.getFullYear()}-${month}-${strDate} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      return datetimeType;
    }
  }
};

</script>

<style scoped>

</style>
